import { Exclude, Expose, Type } from 'class-transformer';
import { BaseModel } from '@core/data-access';

@Exclude()
export class NoticeOfAssessmentModel extends BaseModel {
  @Expose() yearOfAssessment!: string;
  @Expose() category!: string;
  @Expose() taxClearance!: string;
  @Expose() amount!: number;
  @Expose() employment!: number;
  @Expose() trade!: number;
  @Expose() rent!: number;
  @Expose() interest!: number;
}

/** Provenance MyInfo answered the group with — echoed back unchanged, never edited. */
export class NoaHistoryModel extends BaseModel {
  @Expose()
  classification?: string;

  @Expose()
  lastUpdated?: string;

  @Expose()
  lastUpdatedOnly?: string;

  @Expose()
  @Type(() => NoticeOfAssessmentModel)
  noas?: NoticeOfAssessmentModel[];

  @Expose()
  source?: string;
}
